/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：277
 */

"use strict"

export { _5DC5FBFF as a }
export { o as c }
export { i as e }
export { a as g }
export { s as i }
export { c as h }
export { l as b }
export { u as f }
export { d }
var /* [auto-meaningful-name] */_5DC5FBFF = "#5DC5FBFF"
var o = 3
var i = 50
var a = 1
var s = false
var c = false
var l = 30
var u = 0
var d = 9999
export default _5DC5FBFF
